import * as React from 'react';

import Row from 'components/Row';
import Text from 'components/Text';
import LinkConstants from 'constants/LinkConstants';
import OrganizationEngagementBanner from 'organizations/components/OrganizationEngagementBanner';
import { EngagementRating } from 'organizations/constants/EngagementRatings';
import { TEACHER_RECOMMENDATIONS } from 'organizations/constants/OrganizationEngagementViewCopy';

import OrganizationEngagementViewContainer from './OrganizationEngagementViewContainer';
import OrganizationEngagementViewHeading from './OrganizationEngagementViewHeading';
import OrganizationEngagementViewScreenshotFigures from './OrganizationEngagementViewScreenshotFigures';

type Props = {
  eventKey: string;
  onShowRatingsModal: () => void;
  schoolRating?: EngagementRating | undefined;
  schoolsEngagedPercent?: number;
  utmParams: string;
};

export default function OrganizationEngagementViewTeachers({
  eventKey,
  onShowRatingsModal,
  schoolRating,
  schoolsEngagedPercent,
  utmParams,
}: Props) {
  return (
    <Text align="center" element="div" className="OrganizationEngagementViewTeachers">
      <Row size="xxxlarge">
        <header>
          <OrganizationEngagementViewContainer>
            <OrganizationEngagementViewHeading
              subtext={
                schoolsEngagedPercent ? (
                  <React.Fragment>
                    {schoolsEngagedPercent}% of schools in this district are rated{' '}
                    <strong>Engaged</strong>.
                  </React.Fragment>
                ) : null
              }>
              Meaningful engagement starts in the classroom.
            </OrganizationEngagementViewHeading>
          </OrganizationEngagementViewContainer>
        </header>
      </Row>
      <Row size="xxxxxlarge">
        <OrganizationEngagementViewScreenshotFigures
          items={[
            {
              alt: 'Summary of deliveries of messages on Remind',
              caption: 'Increase ongoing engagement with mobile-first notifications.',
              image: require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewTeachers/screenshots/delivery-summary.png'),
              image2x: require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewTeachers/screenshots/delivery-summary@2x.png'),
            },
            {
              alt: 'An example of a message on Remind',
              caption: 'Encourage two-way communication with education-specific safeguards.',
              image: require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewTeachers/screenshots/chat.png'),
              image2x: require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewTeachers/screenshots/chat@2x.png'),
            },
          ]}
        />
      </Row>
      <Row>
        <OrganizationEngagementViewContainer size="small">
          <OrganizationEngagementBanner
            title="Tip for the classroom"
            badgeAction={onShowRatingsModal}
            cta="Learn more about Remind accounts for teachers"
            rating={schoolRating}
            to={`${LinkConstants.TEACHERS}?${utmParams}&utm_content=tips`}
            eventKey={`${eventKey}.teachers.cta.click`}>
            {schoolRating
              ? TEACHER_RECOMMENDATIONS[schoolRating]
              : 'Create class communication channels that reach students and parents on the devices they actually use: their phones.'}
          </OrganizationEngagementBanner>
        </OrganizationEngagementViewContainer>
      </Row>
    </Text>
  );
}
